<template>
    <ui-tooltip class="helper-control" :zIndex="67" direction="left" align="center" :class-extra-name="css.code">
        <img src="@/assets/images/common/wx.webp" class="helper-icon" />
        <img src="@/assets/images/common/wx.webp" class="helper-icon helper-icon-active" />
        <div class="helper-context">{{ $t("Wechat") }}</div>
        <template #content>
            <div :class="css.name">{{ $t("ContactUSWeChat") }}</div>
            <img :class="css.image" src="@/assets/images/common/wechat-code-14de95d3-bc4f-43ee-81fe-ae1fa8fb5f94.webp" />
            <div :class="css.copy" @click="Systems.copyText('rddc-support')">
                <div :class="css.context" class="ellipsis">{{ $t("Wechat") }}: rddc-support</div>
                <div :class="css.button">{{ $t("Copy") }}</div>
            </div>
        </template>
    </ui-tooltip>
</template>

<script lang="ts" setup>
//* 组件库
import { UiTooltip } from "various-ui";
//* 公共函数
import { Systems } from "@/assets/js";
//* 样式
import css from "./index.module.less";
</script>
